import React, { memo, useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const ScannerInput = memo(({
    onBarcodeScanned,
}) => {
    const inputRef = useRef(null)
    const timeoutRef = useRef(null)

    const keepFocus = useCallback(() => {
        if (inputRef.current && document.activeElement !== inputRef.current) {
            inputRef.current.focus()
        }
    }, [])

    const handleInput = useCallback(() => {
        clearTimeout(timeoutRef.current)

        timeoutRef.current = setTimeout(() => {
            const value = inputRef.current?.value?.trim()
            console.log('barcode from event:', value)

            if (value) {
                onBarcodeScanned(value)
            }

            if (inputRef.current) {
                inputRef.current.value = ''
            }
        }, 100)
    }, [])

    useEffect(() => {
        keepFocus()

        const interval = setInterval(keepFocus, 300)

        return () => {
            clearInterval(interval)
            clearTimeout(timeoutRef.current)
        }
    }, [])

    return (
        <input
            ref={inputRef}
            onInput={handleInput}
            inputMode='none'
            style={{
                position: 'fixed',
                top: -100,
                left: -100,
                width: 1,
                height: 1,
                opacity: 0,
            }}
            autoFocus
        />
    )
})

ScannerInput.displayName = 'ScannerInput'

ScannerInput.propTypes = {
    onBarcodeScanned: PropTypes.func,
}

export default ScannerInput
